import { createSite, validateSite } from "./rules";
import type { RawSite, Site } from "./types";

const alderReachRaw: RawSite = {
  schemaVersion: 3,
  rulesetVersion: 3,
  contentVersion: 1,
  id: "alder-reach",
  title: "Alder Reach",
  subtitle: "A neglected field with an older story",
  introduction:
    "The land cooperative has entrusted you with a neglected field. Its grasses, " +
    "stones, and damp hollows suggest that the uneven ground is not random. Develop " +
    "every location, keep the farm solvent, and record what you believe happened here.",
  elevations: [
    [44, 43, 42, 40, 39],
    [42, 40, 39, 38, 38],
    [40, 39, 37, 37, 36],
    [39, 38, 37, 35, 34],
    [42, 41, 39, 37, 35],
  ],
  watercourse: [
    [0, 1],
    [1, 1],
    [2, 2],
    [3, 2],
    [4, 3],
  ],
  road: [
    [0, 3],
    [1, 3],
    [2, 2],
    [3, 1],
    [4, 1],
  ],
  rocky: [
    [0, 0],
    [1, 0],
    [2, 0],
    [0, 4],
    [1, 4],
  ],
  pointsOfInterest: [
    {
      id: "stone-bridge",
      title: "Old stone bridge",
      at: [2, 2],
      description:
        "Dressed foundation stones mark where a farm road crossed the former stream.",
      excavationReward: 30,
      preservationReward: 25,
    },
    {
      id: "farmstead-cellar",
      title: "Farmstead cellar",
      at: [4, 1],
      description:
        "A buried cellar, domestic fragments, and the road trace identify a small farmstead.",
      excavationReward: 34,
      preservationReward: 29,
    },
    {
      id: "stone-lined-well",
      title: "Stone-lined well",
      at: [4, 2],
      description:
        "A carefully lined well sits between the farmstead and the old watercourse.",
      excavationReward: 24,
      preservationReward: 21,
    },
  ],
  ecologicalPreserves: [
    {
      at: [1, 0],
      title: "Exposed geological teaching site",
      reward: 12,
    },
  ],
  startingFunds: {
    easy: 125,
    standard: 82,
    hard: 54,
  },
  historicalAccount:
    "A shallow stream once crossed Alder Reach from the northwest hollow toward the " +
    "southeast boundary. Deep alluvial soils accumulated beside it. A compacted farm " +
    "road later approached from the southwest, crossed on a small stone bridge, and " +
    "continued to a farmstead and well on the eastern rise. When the channel shifted " +
    "away, cultivation gradually concealed the crossing and buildings.",
};

const alderReach = createSite(alderReachRaw);
const issues = validateSite(alderReach);

if (issues.length > 0) {
  throw new Error(`Invalid site: ${issues.join("\n")}`);
}

export const SITE: Site = alderReach;
